import { Link, useNavigate, useParams } from 'react-router-dom'

function Btn() {
  const navigate = useNavigate();

  return (
    <div className='w-full flex flex-row items-center justify-between'>
      <div></div>
      <Link to={"/Users/NewUser"}>
        <div className='text-[20px] font-[200] text-[#fff] px-5 rounded-lg py-2 bg-[#0966AE] font-[Cairo]'>New User</div>
      </Link>
    </div>
  )
}

export default Btn